import { FC, HTMLAttributes } from 'react'
import styles from 'components/atoms/PanePlate/PanePlate.styl'
import cn from 'classnames'

type PanePlateProps =
  & HTMLAttributes<HTMLDivElement>
  & {}
export const PanePlate: FC<PanePlateProps> = (props) => {
  const { children, className, ...restProps } = props

  return (
    <div className={ cn(styles.panePlate, className) } { ...restProps }>
      { children }
    </div>
  )
}
